import { ITutor } from "./i-tutor";
import { Person } from "../persons/person";

export class Tutor extends Person implements ITutor {
    Id: string;
    RelationshipId: number;
    IdCardFront: string;
    IdCardBack: string;
    Ocupation: string;
    IsActive: boolean;
    
    constructor() {
        super();
        this.Id = '-1';
        this.RelationshipId = -1;
        this.Ocupation = '';
        this.IdCardFront = '';
        this.IdCardBack = '';
        this.IsActive = true;
    }
}


// WEBPACK FOOTER //
// ./src/app/main/models/tutors/tutor.ts